module.exports = __webpack_public_path__ + "static/media/Group 2058orange@3x.63f80943.png";